require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./study-ideal-networks-portal-and-cloud-based-results-platform.json") })
        }
      }, "path---study-ideal-networks-portal-and-cloud-based-results-platform");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---study-ideal-networks-portal-and-cloud-based-results-platform!./.cache/json/study-ideal-networks-portal-and-cloud-based-results-platform.json
// module id = 929
// module chunks = 231608221292675